<template>
	<section>
		<div class="d-flex justify-content-between">
			<h3>Delivery</h3>

			<slot name="top"></slot>
		</div>	
		<div class="d-flex flex-row justify-content-between flex-wrap align-items-center">
			<div>
				<p v-if="invoiceDetails.last_issued" class="text-muted">Last sent {{ formatDateTimeToLocal(invoiceDetails.last_issued) }}</p>

				<!-- FEATURE NOT WORKING, DISABLED FOR NOW
				<div v-if="isQuote && invoiceDetails.quote_status == 'Accepted' && !$store.service.ServiceInvoice.find(inv => inv.is_quote == 0)">
					<button class="btn btn-primary" type="button" v-on:click="issuePartialPaymentInvoice">
						Issue Partial Payment Invoice
					</button>
				</div>
				-->
			</div>
			<div v-if="typeName == 'Quote'" style="min-width: 280px;">
				<field label="Quote status"
					col-class="col-sm-5"
					:params="{type: 'select',options:[
						{text:'Pending Approval',value:'Pending Approval'},
						{text:'Accepted',value:'Accepted'},
						{text:'Rejected',value:'Rejected'}
					]}"
					v-model="invoiceDetails.quote_status"
					v-on:change="quoteStatusChange">
				</field>

				<p v-if="invoiceDetails.quote_status == 'Accepted' && apiResource == 'ServiceInvoice'" style="max-width: 300px">In order to make this an active job, you must change the status to "Dispatched" over in the <router-link :to="'/service/'+$route.params.id+'/details'">Service Details</router-link> tab</p>

				<slot name="main"></slot>

				<!--<button  
					v-if="invoiceDetails.quote_rejected == 0"
					v-on:click="toggleQuoteRejected(true)"
					class="btn btn-dark">
					<i class="fa fa-ban"></i>
					Mark as Rejected
				</button>

				<div v-else
					class="text-danger">
					<i class="fa fa-ban"></i>
					The quote has been rejected <small><a href="#" v-on:click.prevent="toggleQuoteRejected(false)">Undo</a></small>
				</div>-->
			</div>
		</div>

		<field 
			class="mb-2"
			:label="typeName+' Total'"
			col-class="col-lg-2 col-md-3 col-sm-4"
			:readonly="true"
			:value="grandTotal">
		</field>

		<field v-if="!isQuote"
			class="mb-2"
			label="Total Requested"
			col-class="col-lg-2 col-md-3 col-sm-4"
			:readonly="true"
			:value="amountDue">
		</field>

		<field v-if="!isQuote"
			class="mb-2"
			label="Paid to Date"
			col-class="col-lg-2 col-md-3 col-sm-4"
			:readonly="true"
			:value="paidToDate">
		</field>

		<field v-if="invoiceDetails.is_paid == 0" 
			label="Delivery Instructions" 
			col-class="stacked" 
			:value="clientInvoiceSettings.invoicingInstructions ? clientInvoiceSettings.invoicingInstructions : ''" 
			:readonly="true" 
			:params="{type:'textarea'}">
		</field>

		<alert v-if="clientInvoiceSettings.invoiceHardCopy == 1 && invoiceDetails.is_processed == 0"
			:unclosable="true"
			:visible="true"
			classes="alert-warning"
			icon="fa-print"
			message="Don't forget to Print! This client requires a hard copy of the invoice">
		</alert>

		<alert v-if="invoiceDetails.is_processed == 1"
			:unclosable="true"
			:visible="true"
			classes="alert-info"
			icon="fa-archive"
			message="This invoice has been marked as Processed">
		</alert>

		<alert v-if="invoiceIsPaidInFull"
			:unclosable="true"
			:visible="true"
			classes="alert-success"
			icon="fa-check"
			message="Paid in full">
		</alert>

		<alert v-if="clientInvoiceSettings.attachDirectly == 1"
			:unclosable="true"
			:visible="true"
			classes="alert-info"
			icon="fa-exclamation-triangle"
			message="The invoice will be attached directly to the email as a PDF. There will be no open/read tracking as a result.">
		</alert>
		<alert v-else
			:unclosable="true"
			:visible="true"
			classes="alert-info"
			icon="fa-exclamation-triangle"
			message="The invoice will be delivered through the document portal. An email notice with a link to download the invoice will be sent.">
		</alert>

		<div class="d-flex flex-row justify-content-between flex-wrap">
			<div>

				<!--<button class="btn btn-light" v-on:click="deFinalize">
					<i class="fa fa-lock-open"></i>
					De-Finalize for Editing
				</button>-->

				<a :href="invoiceDLSrc" class="btn btn-light">
					<i class="fa fa-download"></i>
					Download {{typeName}}
				</a>

				<a v-if="hasAttachedFiles" :href="invoiceDLAttachedFiles" class="btn btn-light">
					<i class="fa fa-paperclip"></i>
					Download Attached Files
				</a>

				<a v-if="clientInvoiceSettings.invoicePortalLink"
					class="btn btn-light" 
					:href="clientInvoiceSettings.invoicePortalLink" 
					target="_blank">

					<i class="fa fa-external-link"></i>

					Go to Client's Invoicing Portal
				</a>

			</div>
			<div>
				<button class="btn btn-primary mr-1" v-on:click="markAsSent">
					<i class="fa fa-paper-plane"></i>
					Mark {{typeName}} as Sent
				</button>
				<button class="btn btn-primary" v-on:click="emailInvoiceModal.visible = true">
					<i class="fa fa-paper-plane"></i>
					Email {{typeName}}
				</button>
			</div>
		</div>

		<send-document-modal :visible="emailInvoiceModal.visible"
			:document-type="typeName"
			:customer="customer"
			v-on:closeModal="emailInvoiceModal.visible = false"
			v-on:send="emailInvoice">
		</send-document-modal>
	</section>
</template>
<script type="text/javascript">
import Field from '@/components/Field'
import Alert from '@/components/Alert'

import SendDocumentModal from "@/components/SendDocumentModal"

import ServiceMixins from "@/mixins/ServiceMixins.js"
import ContactMixins from "@/mixins/ContactMixins.js"

export default {
	name: "InvoiceDeliverySection",
	components: {
		Field,
		Alert,
		SendDocumentModal
	},
	mixins: [ServiceMixins,ContactMixins],
	props: [
		"invoiceDetails",
		"clientInvoiceSettings",
		"hasAttachedFiles",
		"customer",
		"typeName", //"Quote" or "Invoice"
		"apiResource",
	],
	data() {
		return {
			emailInvoiceModal: {
				visible: false
			},
			quoteStatus: ''
		}
	},
	watch: {
		invoiceDetails() {
			if ("quote_status" in this.invoiceDetails)
				this.quoteStatus = this.invoiceDetails.quote_status
		}
	},
	computed: {
		amountDue() {
			let amount = 0

			if ("amount_due" in this.invoiceDetails)
				amount = +this.invoiceDetails.amount_due

			if (amount == 0) {
				if ("amount_paid" in this.invoiceDetails && this.invoiceDetails.amount_paid != 0) {
					let grandTotal = +this.invoiceDetails.grand_total
					let amountPaid = +this.invoiceDetails.amount_paid

					amount = grandTotal - amountPaid
				}
				else
					amount = +this.invoiceDetails.grand_total
			}

			return "$ "+amount.toCurrency()
		},
		grandTotal() {
			let amount = +this.invoiceDetails.grand_total
			return "$ "+amount.toCurrency()
		},
		paidToDate() {
			let amount = +this.invoiceDetails.amount_paid
			return "$ "+amount.toCurrency()
		},
		invoiceIsPaidInFull() {
			if (this.invoiceDetails && (!("is_quote" in this.invoiceDetails) || this.invoiceDetails.is_quote == 0)) { //for service/other invoices
				//if (this.invoiceDetails.amount_due > 0)
				//	return this.invoiceDetails.amount_due == this.invoiceDetails.amount_paid
				//else
					return +this.invoiceDetails.grand_total <= +this.invoiceDetails.amount_paid
			}
			return false
		},
		invoiceDLSrc() {
			return window.apiBase+this.apiResource+"/pdf?slug="+this.invoiceDetails.slug+"&token="+this.$store.sessionToken+"&download=true&humanReadable=true&v="+this.previewRefresher
		},
		invoiceDLAttachedFiles() {
			return window.apiBase+this.apiResource+"/get-attached-files?id="+this.invoiceDetails.slug+"&token="+this.$store.sessionToken+"&humanReadable=true&type=zip"
		}
	},
	methods: {
		deFinalize() {
			this.$emit("deFinalize")
		},
		quoteStatusChange(status) {
			let vm = this

			let payload = {
				id: this.invoiceDetails.id,
				quote_status: status
			}

			this.postData(this.apiResource+"/save",payload,true).then(response => {
				if (response.success) {
					vm.alertSaved("Status changed to "+status)
					vm.$emit("quoteStatusChange",status)
				}
			})
		},
		markAsSent() {
			let vm = this

			let payload = {
				id: this.invoiceDetails.id,
				last_issued: this.moment.utc().format("YYYY-MM-DD H:mm:ss")
			}

			this.postData(this.apiResource+"/save",payload,true).then(response => {
				if (response.success) {

					if (vm.apiResource == 'ServiceInvoice') {
						if (vm.invoiceDetails.is_quote == 0 && (vm.$store.service.status == "Processing" || vm.$store.service.status == "Completed")) {
							vm.postData("Service/save",{id: vm.$store.service.id,status: "Invoiced"}).then(response => {
								if (response.success)
									vm.$store.service.status = "Invoiced"
							})
						}
					}

					vm.alertSuccess(vm.typeName+" marked as sent!")
				}
			})
		},
		emailInvoice(recipients) {
			let vm = this

			let payload = {
				invoice_id: this.invoiceDetails.id,
				additional: recipients.additional,
				recipients: recipients.recipients
			}

			this.postData(this.apiResource+"/send",payload,true).then(response => {
				if (response.success) {
					vm.alertSuccess(vm.typeName+" sent!")
					vm.emailInvoiceModal.visible = false
				}
			})
		},
		issuePartialPaymentInvoice() {
			let vm = this

			this.$emit("generateInvoice",{
				fromQuote: true,
				activeTab: "Finalizing",
				isPartialPayment: true
			})
		}
	},
	created() {
		if ("quote_status" in this.invoiceDetails)
			this.quoteStatus = this.invoiceDetails.quote_status
	}
}
</script>